import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { DatasourceTableStore } from '@y42/datasource';
import { SqlModelingTableGitFactoryService } from './sql-modeling-table-git-factory.service';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'sql-modeling-table', idKey: '$path' })
export class SqlModelingTableStore extends DatasourceTableStore {
  constructor(protected readonly gitFactory: SqlModelingTableGitFactoryService) {
    super('SQL-Modeling-Table', gitFactory);
  }
}
